import { useMutation } from 'react-query';
import { CallGroupApi } from '@frontend/api-call-group';
import { useInvalidateQueries } from '@frontend/location-helpers';
import { queryKeys } from '../../../query-keys';

export const useCallGroupMutations = (phoneTenantId: string) => {
  const invalidateQueries = useInvalidateQueries();

  const remove = useMutation({
    mutationFn: (payload: { callGroupId: string }) => {
      return CallGroupApi.deleteCallGroup(payload);
    },
    onSettled: (_data, _err, payload) => {
      invalidateQueries(queryKeys.listCallGroups(phoneTenantId));
      invalidateQueries(queryKeys.callGroup(payload.callGroupId));
    },
  });

  return {
    remove,
  };
};
